import { render, staticRenderFns } from "./FeatureVerifier.vue?vue&type=template&id=9a853d84&scoped=true"
import script from "./FeatureVerifier.vue?vue&type=script&lang=js"
export * from "./FeatureVerifier.vue?vue&type=script&lang=js"
import style0 from "./FeatureVerifier.vue?vue&type=style&index=0&id=9a853d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a853d84",
  null
  
)

export default component.exports